import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilService } from './http-util.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private httpUtilService: HttpUtilService) { }

    async getLocationLevels(countryId: string):Promise<Observable<HttpResponse<Object>>> {
      const apiEndpoint = 'locations/locationLevels';

      const params = [{
        key: 'countryId',
        value: countryId.toString(),
      }];
      return this.httpUtilService.invokeQueryAnyParams('GET', params, apiEndpoint);
    }

    async getLocations(countryId: string, parentId: number=null):Promise<Observable<HttpResponse<Object>>> {
      const apiEndpoint = 'locations/children';

      let params = [{
        key: 'countryId',
        value: countryId.toString(),
      }];
      if (parentId && parentId > 0)
      {
        params.push({
          key: 'parentId',
          value: parentId.toString()
        })
      }
      return this.httpUtilService.invokeQueryAnyParams('GET', params, apiEndpoint);
    }

    async getAllLocationsForCountry(countryId: string):Promise<Observable<HttpResponse<Object>>> {
      const apiEndpoint = 'locations/countryLocations';

      let params = [{
        key: 'countryId',
        value: countryId.toString(),
      }];

      return this.httpUtilService.invokeQueryAnyParams('GET', params, apiEndpoint);
    }
}
